import { InlineAuthenticationModal } from "../InlineAuthenticationModal";
import { InlineOnboardingModal } from "../InlineOnboardingModal";

// // // //

interface Props {
    children: React.ReactNode;
}

/**
 * InlineAuthProvider
 * Simple wrapper that renders both authentication and onboarding modals
 * Each modal manages its own visibility logic independently
 */
export function InlineAuthProvider({ children }: Props) {
    return (
        <>
            {children}
            <InlineAuthenticationModal />
            <InlineOnboardingModal />
        </>
    );
}
